var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 35.143a5.143 5.143 0 1 0 0-10.286 5.143 5.143 0 0 0 0 10.286m0 2a7.143 7.143 0 1 0 0-14.286 7.143 7.143 0 0 0 0 14.286M40.022 41.002C35.622 41.099 31 44.757 31 52.15c0 1.067.787 2.056 2.53 2.83 1.71.758 4.061 1.162 6.47 1.162s4.76-.404 6.47-1.162c1.743-.774 2.53-1.763 2.53-2.83 0-3.957-1.185-6.761-2.856-8.554a8.06 8.06 0 0 0-6.122-2.595m7.584 1.231c2.08 2.23 3.394 5.555 3.394 9.918 0 2.261-1.713 3.768-3.72 4.658-2.04.905-4.689 1.334-7.28 1.334s-5.24-.429-7.28-1.334c-2.007-.89-3.72-2.397-3.72-4.658 0-8.365 5.378-13.025 10.978-13.149a10.06 10.06 0 0 1 7.628 3.231",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M40 68c15.464 0 28-12.536 28-28S55.464 12 40 12 12 24.536 12 40s12.536 28 28 28m0 2c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30 0 16.569 13.432 30 30 30",
    clipRule: "evenodd"
  })));
};
export default SvgProfile;